// extracted by mini-css-extract-plugin
export default {"stickyView":"StickyView__stickyView___RumLK","stickyViewSticky":"StickyView__stickyViewSticky___XjQ4B"};